/**
 * exec the function  N milliseconds after last invocation
 * params :
 *  - func : the function to debouce
 *  - wait : delay after last invocation (in ms)
 *  - immediate (optional) : call func() at first invocation instead of last (default is False)
 *
 * sources : https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_debounce
 */
module.exports = function debounce(func, wait, immediate) {

  if (typeof func !== 'function') return console.error('invalid function');
  if (typeof wait !== 'number') return console.error('invalid delay');
  if (immediate && typeof immediate !== 'boolean') return console.error('invalid immediate condition, must be boolean');

  let timeout;
  return function debounceFn(...args) {
    const context = this;

    if (immediate && !timeout) func.apply(context, args);

    clearTimeout(timeout);
  	timeout = setTimeout(() => {
  		timeout = null;
  		if (!immediate) func.apply(context, args);
    }, wait);
  };
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-debounce.js